export const images = [
    {
        id: 'img-1',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/1bc7e333-b1ec-43f5-b31e-8ee59477079f/MARTA_BRANDAO_AROUCA_LOW-95.jpg',
    },
    {
        id: 'img-2',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/2d347c9a-1dcc-4a1e-8cd3-f81ce0e9595d/MARTA_BRANDAO_AROUCA_LOW-6.jpg',
    },
    {
        id: 'img-3',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/7e7acc05-a1c5-4580-b92a-e493f8d8a4d0/MARTA_BRANDAO_AROUCA_LOW-45.jpg',
    },
    {
        id: 'img-4',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/aea352e5-091e-4070-b39d-332c33182b3d/MARTA_BRANDAO_AROUCA_LOW-19.jpg',
    },
    {
        id: 'img-5',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/0469e256-8946-4b7a-8bb7-41371705ae14/MARTA_BRANDAO_AROUCA_LOW-86.jpg',
    },
    {
        id: 'img-6',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/2ec65a71-7ddd-4c6b-a324-760cce0ad094/MARTA_BRANDAO_AROUCA_LOW-78.jpg',
    },
    {
        id: 'img-7',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/42a43c2f-d828-487d-8f5a-69d3217ca4a5/MARTA_BRANDAO_AROUCA_LOW-35.jpg',
    },
    {
        id: 'img-8',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/3a7a7635-1b70-48d7-8ddf-69b08fbbbf19/MARTA_BRANDAO_AROUCA_LOW-13.jpg',
    },
    {
        id: 'img-9',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/461f2710-0207-4e0c-ae71-48dfe4d8cb7b/MARTA_BRANDAO_AROUCA_LOW-30.jpg',
    },
    {
        id: 'img-10',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/35bd4668-eb4b-4364-8eff-f6bba9b4136f/MARTA_BRANDAO_AROUCA_LOW-18.jpg',
    },
    {
        id: 'img-11',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/1898d1dc-551e-4d2b-8104-3d375028cf5d/MARTA_BRANDAO_AROUCA_LOW-31.jpg',
    },
    {
        id: 'img-12',
        imgURL:'https://images.squarespace-cdn.com/content/v1/63566161d13f2053d113aa4a/cd698726-92fd-46d0-beeb-8b2169331334/MARTA_BRANDAO_AROUCA_LOW-71.jpg',
    }
  ]